export const DemoDatasets = [
    "6b4901f0-5bcb-40cd-b40a-fff0e3eb005a",
    "aa615c0c-dee9-4ce1-a444-8e6f15a89e8b",
    "382473d0f08c1d27f5f0efd4878609aaa25dd81e76b99c739836b36be39c56f2",
    "be046026-d772-4ae3-9945-ffadc58d410e"
  ];
  